import script from "./ServiceContacts.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceContacts.vue?vue&type=script&setup=true&lang=js"

import "./ServiceContacts.vue?vue&type=style&index=0&id=58619a31&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58619a31"]])

export default __exports__